export default "__VITE_PUBLIC_ASSET__5a12f3af__"